/*
 * Copyright 2018 Teralytics
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var styles = {
    outer: {
        position: 'absolute',
        background: '#fff',
        padding: 10,
        borderRadius: 4,
        border: '1px solid #ccc',
    },
};
var LegendBox = function (_a) {
    var style = _a.style, top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom, children = _a.children;
    return (React.createElement("div", { style: __assign(__assign(__assign({}, styles.outer), style), { top: top,
            left: left,
            right: right,
            bottom: bottom }) }, children));
};
export default LegendBox;
//# sourceMappingURL=LegendBox.js.map